<template>
  <section style="text-align: center;">
    <v-scale-transition>
      <v-icon
        color="success"
        size="64"
      >
        check_circle
      </v-icon>
    </v-scale-transition>
    <h3>Iremos processar seu pagamento!</h3>
    <p>Código do pagamento: {{ payment.id }}</p>
    <p>Status do pagamento: {{ payment.status.label }}</p>
    <p>Valor pago: R$ {{ payment.value.formatted }}</p>      
  </section>   
</template>

<script>
  export default {
    name: 'OrderPaymentInfoSuccess',
    props: {
      payment: {
        type: Object,
        required: true
      }
    },
    data: () => ({    
    }),
  };
</script>